// extracted by mini-css-extract-plugin
export default {"TemplateFull":"TemplateFull_TemplateFull__PRqYh","wrapper":"TemplateFull_wrapper__S2I6o","alert":"TemplateFull_alert__kyEj5","content":"TemplateFull_content__hgoEM"};